import { matchSorter } from 'match-sorter';
import type { FilterValue, Row } from 'react-table';
import DefaultColumnFilter from './text-filter';

export const fuzzyTextFilterFn = <Data extends Record<string, unknown>>(
  rows: Array<Row<Data>>,
  columnIds: Array<string>,
  filterValue: FilterValue
): Array<Row<Data>> =>
  matchSorter<Row<Data>>(rows, filterValue, {
    keys: columnIds.map((id) => `values.${id}`)
  });

fuzzyTextFilterFn.autoRemove = (val: boolean): boolean => !val;

export const FuzzyFilter = {
  filterType: 'fuzzyText',
  Filter: DefaultColumnFilter,
  filter: fuzzyTextFilterFn
};
